import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupAdminsList } from '../../../../global/ducks/wam-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { Group } from '../groups/groups-model';
import { OfficerAdminState } from './institution-officers-models';
import { beginGroupAdminRequest, dispatchSetGroupAdmins, endGroupAdminRequest } from './institution-officers-slices';


export function useGroupAdmins() {
	const dispatch = useDispatch();
	const groupAdminState = useSelector<TcsmStates, OfficerAdminState>(state => state.officerAdminState);
	const group = useSelector<TcsmStates, Group>(state => state.groupsState.currentGroup);
	useEffect(() => {
		if (!groupAdminState.groupAdminsLoaded && !groupAdminState.requestingGroupAdmin && group) {
			dispatch(beginGroupAdminRequest());
			dispatch(getGroupAdminsList(group.client_number, (response) => { dispatchSetGroupAdmins(response, dispatch); },
				() => {
					dispatch(endGroupAdminRequest());
				},
			));

		}
	}, []);

	return groupAdminState;
}